import React from 'react';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% { opacity: 0.4; transform: scale(0.95); }
  50% { opacity: 1; transform: scale(1); }
`;

const Wrap = styled.div`
  position: fixed;
  inset: 0;
  background: #0a0a0f;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const Logo = styled.div`
  font-size: 32px;
  font-weight: 900;
  color: #fff;
  animation: ${pulse} 1.5s ease infinite;
  span { color: #006FFF; }
`;

const Sub = styled.div`
  margin-top: 12px;
  color: rgba(255,255,255,0.3);
  font-size: 13px;
  font-weight: 500;
`;

const LoadingScreen = () => (
  <Wrap>
    <Logo>Open<span>PS</span></Logo>
    <Sub>Загрузка...</Sub>
  </Wrap>
);

export default LoadingScreen;
